<template>
  <div>
    <!--Company-->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
name: "Company"
}
</script>

<style scoped>

</style>